import { render, staticRenderFns } from "./ProfileInfoPage.vue?vue&type=template&id=0711bef1&scoped=true&"
import script from "./ProfileInfoPage.vue?vue&type=script&lang=js&"
export * from "./ProfileInfoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0711bef1",
  null
  
)

export default component.exports